export default __webpack_public_path__ + "static/Hero-dab0fc1f6d0338602863f23e7be75c42.png";